import { CardsGrid, SectionContainer, EmptyState } from '../styles/TrainingViewStyles';
import SectionHeader from './SectionHeader';
import EntryCard from './EntryCard';

const CardsGridView = ({
  unreadEntries,
  readEntries,
  entries,
  isAdmin,
  onEntrySelect,
  currentUserId,
}) => {
  // If admin, show all entries without filtering
  if (isAdmin) {
    return (
      <>
        {entries.length > 0 ? (
          <SectionContainer>
            <SectionHeader
              type="all"
              title="Todas las asignaciones"
              count={entries.length}
              icon="fa-solid fa-list"
            />
            <CardsGrid>
              {entries.map((entry) => (
                <EntryCard
                  key={entry.id}
                  entry={entry}
                  currentUserId={currentUserId}
                  onSelect={onEntrySelect}
                />
              ))}
            </CardsGrid>
          </SectionContainer>
        ) : (
          <EmptyState>
            <i className="fa-solid fa-inbox"></i>
            <h3>No hay asignaciones creadas</h3>
            <p>Puedes crear una nueva asignación desde el botón de la esquina superior derecha.</p>
          </EmptyState>
        )}
      </>
    );
  }

  // Non-admin: show filtered sections
  return (
    <>
      {/* Unread Entries Section */}
      {unreadEntries.length > 0 ? (
        <SectionContainer>
          <SectionHeader
            type="unread"
            title="Pendientes por completar"
            count={unreadEntries.length}
            icon="fa-solid fa-circle-exclamation"
          />
          <CardsGrid>
            {unreadEntries.map((entry) => (
              <EntryCard
                key={entry.id}
                entry={entry}
                currentUserId={currentUserId}
                onSelect={onEntrySelect}
              />
            ))}
          </CardsGrid>
        </SectionContainer>
      ) : (
        <EmptyState>
          <i className="fa-solid fa-inbox"></i>
          <h3>¡Estás al día!</h3>
          <p>No hay asignaciones pendientes por completar.</p>
        </EmptyState>
      )}

      {/* Read Entries Section */}
      {readEntries.length > 0 && (
        <SectionContainer>
          <SectionHeader
            type="read"
            title="Completadas"
            count={readEntries.length}
            icon="fa-solid fa-check-circle"
          />
          <CardsGrid>
            {readEntries.map((entry) => (
              <EntryCard
                key={entry.id}
                entry={entry}
                currentUserId={currentUserId}
                onSelect={onEntrySelect}
              />
            ))}
          </CardsGrid>
        </SectionContainer>
      )}
    </>
  );
};

export default CardsGridView;
